import axios from "axios";

const DataService = {
  nnc: function() {
    const timestamp = new Date().getTime();
    const lettersMap = Array.from({ length: 10 }, (_, i) =>
      String.fromCharCode(97 + i)
    );

    const timestampStr = timestamp.toString();

    let cstr = "";
    for (let i = 0; i < timestampStr.length; i++) {
      const digit = parseInt(timestampStr[i], 10);
      cstr += lettersMap[digit];
    }

    return cstr
      .split("")
      .reverse()
      .join("");
  },
  tk: async function() {
    const res = await axios.get(
      this.apiBasePath() + "/applications/nonce?k=" + this.nnc()
    );
    return res.data;
  },
  apiBasePath: function() {
    return "https://admincandidature.eavsrl.it/api";
  },
  getFormBando: async function(setForm, setInternal, modifyJson, code) {
    const bearer = await this.tk();

    return axios
      .get(this.apiBasePath() + "/forms/" + code + "/data", {
        headers: {
          Authorization: `Bearer ${bearer}`,
        },
      })
      .then((res) => {
        if (modifyJson) {
          modifyJson(res.data);
        }
        setForm(res.data);
        setInternal(res.data.internal);
      });
  },

  getFormDettaglio: async function(setForm, modifyJson, code) {
    const bearer = await this.tk();
    sessionStorage.setItem("formCode", code);
    return axios
      .get(this.apiBasePath() + "/forms/" + code + "/data", {
        headers: {
          Authorization: `Bearer ${bearer}`,
        },
      })
      .then((res) => {
        if (modifyJson) {
          modifyJson(res.data);
        }
        setForm(res.data);
      });
  },

  sendForm: async function(jsonForm) {
    const bearer = await this.tk();
    const formId = sessionStorage.getItem("formCode");
    return axios
      .post(
        this.apiBasePath() + "/applications",
        {
          data: {
            form: jsonForm.id || formId,
            payload: jsonForm,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${bearer}`,
          },
        }
      )
      .then((res) => console.log("Invio Form andato a buon fine!"))
      .catch(function(error) {
        console.log("Errore!");
        console.log("JSON FORM : ", jsonForm);
        if (error.res) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.res.data);
          console.log(error.res.status);
          console.log(error.res.headers);
        } else if (error.request) {
          // The request was made but no res was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);
          alert("Error", error.message);
        }
        console.log(error.config);
      });
  },

  sendFormResponsabile: async function(jsonForm, nome, email) {
    const bearer = await this.tk();
    return axios
      .post(
        this.apiBasePath() + "/applications",
        {
          data: {
            form: jsonForm.id,
            payload: jsonForm,
            ccname: nome,
            ccemail: email,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${bearer}`,
          },
        }
      )
      .then((res) => console.log("Invio Form andato a buon fine!"))
      .catch(function(error) {
        console.log("Errore!");
        console.log("JSON FORM : ", jsonForm);
        if (error.res) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.res.data);
          console.log(error.res.status);
          console.log(error.res.headers);
        } else if (error.request) {
          // The request was made but no res was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);
          alert("Error", error.message);
        }
        console.log(error.config);
      });
  },

  uploadFiles_backup: async function(files) {
    const bearer = await this.tk();
    return axios
      .post(this.apiBasePath() + "/upload", files, {
        headers: {
          Authorization: `Bearer ${bearer}`,
        },
      })
      .then((res) => {
        console.log("Upload file andato a buon fine!");
        console.log("upload file res: " + res.data);
      })
      .catch(function(error) {
        console.log("Errore!");
        if (error.res) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.res.data);
          console.log(error.res.status);
          console.log(error.res.headers);
        } else if (error.request) {
          // The request was made but no res was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);
          alert("Error", error.message);
        }
        console.log(error.config);
      });
  },

  uploadFile: async function(files, i, callback) {
    const bearer = await this.tk();
    const formData = new FormData();

    console.log("files[i] : ", files[i]);
    const _file = files[i].file;
    formData.append("files", files[i].file);

    const r = await fetch(this.apiBasePath() + "/upload", {
      method: "post",
      body: formData,
      headers: {
        Authorization: `Bearer ${bearer}`,
      },
    });

    const res = await r.json();
    console.log(res);
    try {
      files[i].path = res.map((r) => r.url);
    } catch (error) {}

    if (i < files.length - 1) {
      this.uploadFile(files, i + 1, callback);
    } else {
      callback && callback();
    }
  },

  uploadFiles: function(files, callback) {
    this.uploadFile(files, 0, callback);
  },

  createUser: async function() {
    const bearer = await this.tk();
    return axios
      .post(
        this.apiBasePath() + "/auth/local/register",
        {
          username: "prova",
          email: "test@yopmail.com",
          password: "provaPassword",
        },
        {
          headers: {
            Authorization: `Bearer ${bearer}`,
          },
        }
      )
      .then((res) => console.log("res: ", res))
      .catch(function(error) {
        console.log(error);
      });
  },

  getUsers: async function() {
    const bearer = await this.tk();
    return axios
      .get(this.apiBasePath() + "/users", {
        headers: {
          Authorization: `Bearer ${bearer}`,
        },
      })
      .then((res) => {
        console.log(res);
      });
  },
/*
  checkCF: async function(cf) {
  const bearer = await this.tk();
  return axios
    .get(this.apiBasePath() + "/forms/checkCF/" + cf, {
      headers: {
        Authorization: `Bearer ${bearer}`,
      },
    })
    .then((res) => {
      return res;
    });
}*/
checkCF: async function(cf, idBando) {
  const bearer = await this.tk();
  
  // Costruiamo l'URL aggiungendo ?idBando= in coda
  const url = `${this.apiBasePath()}/forms/checkCF/${cf}${idBando ? `?idBando=${idBando}` : ""}`;
  
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${bearer}`,
    },
  }).then((res) => {
    return res;
  });
}
,
};

export default DataService;
